import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#fff" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Our Result-Driven <span>Telecom Software Development </span>
              Services
            </h2>
            <p>
              We offer a variety of telecom IT services to assist operators and
              service providers in optimizing their business processes and
              improving the customer experience.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              hire our software developers today
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Telecom Billing Software Development</h4>
                  <p>
                    Our Telecom billing software enables better invoicing and
                    custom pricing plans, providing instant reporting to enhance
                    billing performance.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Telecom Audit Software Development</h4>
                  <p>
                    Our telecom software development services help companies
                    conduct effective audits of their communication
                    infrastructure and offerings to decrease expenses and boost
                    operational efficiency.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Call Accounting Software Development</h4>
                  <p>
                    Our call accounting software helps businesses ensure that
                    they stay informed on their expenses in terms of call costs
                    so that they can avoid wastage and make productive use of
                    available resources.
                  </p>
                </div>

                <div className="robust-content">
                  <h4>Live Video Streaming Software Development</h4>
                  <p>
                    As a leading telecom software company, we provide solutions
                    to streamline processes, boost customer relations, and drive
                    revenue. Our high-quality streaming enhances viewer
                    retention and monetization.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>IPTV Solutions</h4>
                  <p>
                    Our IPTV solution allows providers to offer seamless
                    on-demand video streaming, delivering premium content
                    without interruptions. This boosts viewer loyalty and
                    creates new revenue opportunities.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Operations Support Systems (OSS) Development</h4>
                  <p>
                    Our OSS platform automates network functions, reduces
                    downtime, & enhances service quality to meet customer
                    demands. This automation enables quick responses to network
                    issues & ensures quality service.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Business Support Systems (BSS) Development</h4>
                  <p>
                    Our custom BSS development services improve billing and
                    customer service to help telecom firms deliver worthwhile
                    and individualized experiences to their clients.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>VAS (Value Added Services) Software Development</h4>
                  <p>
                    Our VAS software development services can assist telecom
                    firms in coming up with such value-added services as mobile
                    banking and mobile entertainment which help the firms to
                    differentiate themselves.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
